import { RuleSchema, RuleJsonModel } from '../../domain/collection/rule/FlowDomains';
import WorkFlowView from '../../components/rule/workflow/view/WorkFlowView';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { RuleActions } from '../actions/RuleActions';
import ValueFactory from '../../util/ValueFactory';

export interface RuleState {
  rule: RuleJsonModel;
  ruleSchema: RuleSchema | null;
  workflowView: WorkFlowView | null;
  isUpdate: boolean;
  isDirty: boolean;
}

const initialState: RuleState = {
  rule: ValueFactory.initializeRule(),
  ruleSchema: null,
  workflowView: null,
  isUpdate: false,
  isDirty: false,
};

export const ruleReducer = (state = initialState, action: ReduxBaseAction<any, RuleActions>): RuleState => {
  switch (action.type) {
    case 'CHANGE_RULE':
      return { ...state, rule: action.payload };
    case 'CHANGE_RULE_SCHEMA':
      return { ...state, ruleSchema: action.payload };
    case 'CHANGE_RULE_WORKFLOW_VIEW':
      return { ...state, workflowView: action.payload };
    case 'CHANGE_RULE_IS_UPDATE':
      return { ...state, isUpdate: action.payload };
    case 'CLEAR_RULE':
      return { ...state, rule: ValueFactory.initializeRuleByType(action.payload), ruleSchema: null, workflowView: null, isUpdate: false };
    case 'CHANGE_RULE_DIRTY':
      return { ...state, isDirty: action.payload };
    default:
      return state;
  }
};
